/* Salvona — scroll-driven 3D capsule "build" (no dependencies)
   Stages (continuous s from 0 to 5):
   0 active · 1 core · 2 shell · 3 surface/skin · 4 release · 5 scale */
(function(){
  'use strict';
  var RM = window.matchMedia && matchMedia('(prefers-reduced-motion: reduce)').matches;

  function clamp(v,a,b){return v<a?a:v>b?b:v;}
  function lerp(a,b,t){return a+(b-a)*t;}
  function smooth(x,a,b){var t=clamp((x-a)/(b-a),0,1);return t*t*(3-2*t);}
  function hexRgb(h){h=h.replace('#','');if(h.length===3)h=h.split('').map(function(c){return c+c;}).join('');var n=parseInt(h,16);return [n>>16&255,n>>8&255,n&255];}
  function mix(h,k,t){var a=hexRgb(h),b=hexRgb(k);return 'rgb('+Math.round(lerp(a[0],b[0],t))+','+Math.round(lerp(a[1],b[1],t))+','+Math.round(lerp(a[2],b[2],t))+')';}
  function rnd(seed){return function(){seed=(seed*16807)%2147483647;return (seed-1)/2147483646;};}

  /* shaded ball sprite */
  function sprite(color,size){
    var c=document.createElement('canvas');c.width=c.height=size;var g=c.getContext('2d');
    var r=size/2,gr=g.createRadialGradient(r*.72,r*.62,r*.05,r,r,r);
    gr.addColorStop(0,'#ffffff');gr.addColorStop(.18,mix(color,'#ffffff',.55));gr.addColorStop(.55,color);gr.addColorStop(1,mix(color,'#06122a',.55));
    g.fillStyle=gr;g.beginPath();g.arc(r,r,r*.96,0,Math.PI*2);g.fill();return c;
  }
  function glow(color,size){
    var c=document.createElement('canvas');c.width=c.height=size;var g=c.getContext('2d');var r=size/2;
    var gr=g.createRadialGradient(r,r,0,r,r,r);var a=hexRgb(color);
    gr.addColorStop(0,'rgba('+a+',.55)');gr.addColorStop(.5,'rgba('+a+',.18)');gr.addColorStop(1,'rgba('+a+',0)');
    g.fillStyle=gr;g.fillRect(0,0,size,size);return c;
  }

  function Build(root){
    this.root=root;
    this.stage=root.querySelector('[data-svb-stage]');
    this.cv=root.querySelector('canvas');
    this.ctx=this.cv.getContext('2d');
    this.steps=[].slice.call(root.querySelectorAll('[data-svb-step]'));
    this.huds=[].slice.call(root.querySelectorAll('[data-svb-from]'));
    this.bar=root.querySelector('[data-svb-bar]');
    this.count=root.querySelector('[data-svb-count]');
    var d=root.dataset;
    this.cfg={
      c1:d.c1||'#2E6CC8', c2:d.c2||'#9DB9E6', act:d.act||'#FF8A5B', core:d.core||'#E8C27A', act2:d.act2||d.c2||'#9DB9E6',
      shell:d.shell||'lattice', release:d.release||'diffuse', charge:d.charge||'plus'
    };
    this.s=0;this.target=0;this.t=0;this.visible=false;this.N=Math.max(2,this.steps.length);
    this.build();this.resize();this.bind();
  }

  Build.prototype.build=function(){
    var R=rnd(7),i,c=this.cfg;
    this.spr={act:sprite(c.act,64),core:sprite(c.core,64),shell:sprite(c.c1,48),shell2:sprite(c.c2,48),mini:sprite(c.c1,96),act2:sprite(c.act2,64)};
    this.glowCore=glow(c.core,256);this.glowAct=glow(c.act,256);this.glowC1=glow(c.c1,256);
    /* active particles */
    this.A=[];for(i=0;i<150;i++){
      var u=R()*2-1,th=R()*Math.PI*2,rr=Math.cbrt(R())*.48,sq=Math.sqrt(1-u*u);
      this.A.push({
        sx:(R()*2-1)*2.3, sy:(R()*2-1)*1.35, sz:(R()*2-1)*.8,
        cx:rr*sq*Math.cos(th), cy:rr*u, cz:rr*sq*Math.sin(th),
        ph:R()*6.28, sp:.6+R()*1.2, d:R()*.82, rx:(R()-.5), ry:R(), sz2:.75+R()*.5,
        second: (this.cfg.release==='sequence'||this.cfg.release==='burst') && i%2===0
      });
    }
    /* core (wax / lipid) particles */
    this.C=[];for(i=0;i<380;i++){
      var u2=R()*2-1,th2=R()*Math.PI*2,r2=Math.cbrt(R())*.66,sq2=Math.sqrt(1-u2*u2),far=2.6+R()*1.2,u3=R()*2-1,th3=R()*6.28,sq3=Math.sqrt(1-u3*u3);
      this.C.push({x:r2*sq2*Math.cos(th2),y:r2*u2,z:r2*sq2*Math.sin(th2),fx:far*sq3*Math.cos(th3),fy:far*u3*.7,fz:far*sq3*Math.sin(th3),d:R()*.5});
    }
    /* shell points (fibonacci sphere) */
    this.S=[];var n=560,ga=Math.PI*(3-Math.sqrt(5));
    for(i=0;i<n;i++){var y=1-(i/(n-1))*2,rad=Math.sqrt(1-y*y),a=ga*i;this.S.push({x:Math.cos(a)*rad,y:y,z:Math.sin(a)*rad,d:R()});}
    /* charges */
    this.Q=[];for(i=0;i<16;i++){var a2=i/16*Math.PI*2,yy=(R()-.5)*1.2,rq=Math.sqrt(1-yy*yy*.6);this.Q.push({x:Math.cos(a2)*rq*1.2,y:yy,z:Math.sin(a2)*rq*1.2});}
    /* mini spheres for the scale view */
    this.M=[];for(i=0;i<70;i++){this.M.push({x:R(),y:R(),r:.35+R()*.9,ph:R()*6.28,sp:.2+R()*.5});}
  };

  Build.prototype.resize=function(){
    var r=this.cv.getBoundingClientRect(),dpr=Math.min(window.devicePixelRatio||1,2);
    this.w=r.width;this.h=r.height;this.cv.width=Math.round(r.width*dpr);this.cv.height=Math.round(r.height*dpr);
    this.ctx.setTransform(dpr,0,0,dpr,0,0);
  };

  Build.prototype.bind=function(){
    var self=this;
    if('ResizeObserver' in window){new ResizeObserver(function(){self.resize();}).observe(this.cv);}else{addEventListener('resize',function(){self.resize();});}
    if('IntersectionObserver' in window){new IntersectionObserver(function(es){self.visible=es[0].isIntersecting;if(self.visible)self.kick();},{rootMargin:'200px'}).observe(this.root);}else{this.visible=true;}
    document.addEventListener('scroll',function(){self.measure();},{passive:true,capture:true});
    addEventListener('resize',function(){self.measure();});
    this.measure();this.kick();
  };

  Build.prototype.measure=function(){
    /* follow the step copy: s = index of the step whose card sits at the reading line, plus progress to the next */
    var cards=this.steps,n=cards.length,line=innerHeight*(innerWidth<1100?.76:.55),c=[],i;
    for(i=0;i<n;i++){var r=(cards[i].firstElementChild||cards[i]).getBoundingClientRect();c.push(r.top+r.height/2);}
    var mob=innerWidth<1100;
    for(i=0;i<n;i++){var card=cards[i].firstElementChild;if(!card)continue;
      if(mob){var dd=Math.abs(c[i]-line)/innerHeight;card.style.opacity=(1-smooth(dd,.17,.33)).toFixed(3);}else if(card.style.opacity){card.style.opacity='';}}
    if(line<=c[0]){this.target=0;return;}
    if(line>=c[n-1]){this.target=n-1;return;}
    for(i=0;i<n-1;i++){if(line>=c[i]&&line<c[i+1]){this.target=i+(line-c[i])/(c[i+1]-c[i]);return;}}
  };

  Build.prototype.kick=function(){
    if(this.raf)return;var self=this,last=performance.now();
    function loop(now){
      var dt=Math.min(.05,(now-last)/1000);last=now;
      self.t+=RM?0:dt;self.measure();
      self.s+=(self.target-self.s)*(RM?1:Math.min(1,dt*6));
      self.draw();self.ui();
      if(self.visible||Math.abs(self.target-self.s)>.001)self.raf=requestAnimationFrame(loop);else self.raf=null;
    }
    this.raf=requestAnimationFrame(loop);
  };

  Build.prototype.ui=function(){
    var s=this.s,idx=clamp(Math.round(s),0,this.N-1);
    if(idx!==this.idx){this.idx=idx;this.steps.forEach(function(el,i){el.classList.toggle('is-on',i===idx);});
      if(this.count)this.count.textContent=('0'+(idx+1)).slice(-2);
      this.stage.dataset.scene=idx;}
    if(this.bar)this.bar.style.transform='scaleX('+(s/(this.N-1)).toFixed(4)+')';
    this.huds.forEach(function(h){
      var a=+h.dataset.svbFrom,b=+h.dataset.svbTo,k=smooth(s,a-.55,a-.3)*(1-smooth(s,b+.3,b+.55));
      h.style.opacity=k.toFixed(3);h.style.setProperty('--k',k.toFixed(3));
      var dr=h.dataset.svbDraw;if(dr!==undefined){var a2=+h.dataset.svbDraw,b2=+h.dataset.svbDrawTo;h.style.setProperty('--draw',smooth(s,a2,b2).toFixed(3));}
    });
  };

  Build.prototype.draw=function(){
    var g=this.ctx,w=this.w,h=this.h,s=this.s,t=this.t,c=this.cfg;if(!w||!h)return;
    g.clearRect(0,0,w,h);
    /* stage parameters */
    var scatter=1-smooth(s,.05,1),coreA=smooth(s,.25,1.05),shellK=smooth(s,1.15,2),skin=smooth(s,2.35,3.05),
        charge=smooth(s,2.3,3)*(1-smooth(s,4.2,4.8)),rel=smooth(s,3.25,4.55),zoom=smooth(s,4.3,5),
        shell2=c.shell==='double'?smooth(s,1.35,2.05):0;
    var base=Math.min(w,h)*(w<700?.30:.27),R=base*(1-.78*zoom);
    var cx=w*.5,cy=h*.47-skin*(1-zoom)*h*.1;
    var skinTop=cy+R*1.18;
    var ay=t*.32+s*.75,ax=.38,ca=Math.cos(ay),sa=Math.sin(ay),cx2=Math.cos(ax),sx2=Math.sin(ax),F=4.2;
    var items=[];
    function proj(x,y,z){var x1=x*ca+z*sa,z1=-x*sa+z*ca,y2=y*cx2-z1*sx2,z2=y*sx2+z1*cx2,p=F/(F+z2);return [cx+x1*p*R,cy+y2*p*R,z2,p];}

    /* scale view: field of mini capsules in water */
    if(zoom>.01){
      for(var m=0;m<this.M.length;m++){var o=this.M[m],mx=o.x*w,my=(o.y*h+Math.sin(t*o.sp+o.ph)*14),mr=base*.1*o.r;
        if(Math.hypot(mx-cx,my-cy)<base*.5)continue;
        g.globalAlpha=zoom*.9;g.drawImage(this.spr.mini,mx-mr,my-mr,mr*2,mr*2);
        g.globalAlpha=zoom*.35;g.strokeStyle=c.c2;g.lineWidth=1;g.beginPath();g.arc(mx,my,mr*1.25,0,6.283);g.stroke();}
      g.globalAlpha=1;
    }

    /* skin */
    if(skin>.01&&zoom<.99){
      var ka=skin*(1-zoom);g.save();g.globalAlpha=ka;
      var gr=g.createLinearGradient(0,skinTop,0,h);gr.addColorStop(0,'#FBE4DA');gr.addColorStop(.35,'#F6D0C0');gr.addColorStop(1,'#EDB6A0');
      g.fillStyle=gr;g.beginPath();g.moveTo(0,h);
      for(var xx=0;xx<=w;xx+=12){g.lineTo(xx,skinTop+Math.sin(xx*.018+t*.6)*4);}g.lineTo(w,h);g.closePath();g.fill();
      /* corneocyte bricks */
      g.strokeStyle='rgba(176,104,82,.22)';g.lineWidth=1;
      for(var row=0;row<4;row++){var yy=skinTop+10+row*14,off=row%2?24:0;g.beginPath();g.moveTo(0,yy);g.lineTo(w,yy);g.stroke();
        for(var bx=off;bx<w;bx+=48){g.beginPath();g.moveTo(bx,yy);g.lineTo(bx,yy+14);g.stroke();}}
      /* negative skin charges */
      if(c.charge==='plus'){g.fillStyle='rgba(120,60,45,.8)';g.font='700 17px ui-monospace,monospace';g.textAlign='center';
        for(var nx=36;nx<w;nx+=64){g.fillText('−',nx,skinTop+30);}}
      g.restore();
    }

    /* core glow */
    var coreR=.66*(1-.35*rel);
    if(coreA>.01){var gp=proj(0,0,0),gs=R*coreR*2.6;g.globalAlpha=coreA*.85;g.drawImage(this.glowCore,gp[0]-gs,gp[1]-gs,gs*2,gs*2);g.globalAlpha=1;}
    if(scatter>.05){var ga2=scatter*.5,gs2=base*1.9;g.globalAlpha=ga2;g.drawImage(this.glowAct,cx-gs2,cy-gs2,gs2*2,gs2*2);g.globalAlpha=1;}

    var i,P,q;
    /* core particles */
    for(i=0;i<this.C.length;i++){q=this.C[i];var k=smooth(coreA,q.d,q.d+.5),sh=1-.35*rel;
      P=proj(lerp(q.fx,q.x*sh,k),lerp(q.fy,q.y*sh,k),lerp(q.fz,q.z*sh,k));
      items.push({z:P[2],x:P[0],y:P[1],r:R*.058*P[3],img:this.spr.core,a:k*.95});}
    /* active particles */
    for(i=0;i<this.A.length;i++){q=this.A[i];
      var jit=scatter*.07,ph=q.ph+t*q.sp;
      var qcx=q.cx,qcy=q.cy,qcz=q.cz,scq=scatter;
      if(q.second&&c.release==='sequence'){var ln=Math.sqrt(qcx*qcx+qcy*qcy+qcz*qcz)+.001,kk=(1.13+q.ry*.06)/ln;qcx*=kk;qcy*=kk;qcz*=kk;scq=1-smooth(s,1.2+q.d*.2,1.75+q.d*.2);jit=scq*.07;}
      var lx=lerp(qcx,q.sx,scq)+Math.sin(ph)*jit,ly=lerp(qcy,q.sy,scq)+Math.cos(ph*1.3)*jit,lz=lerp(qcz,q.sz,scq);
      P=proj(lx,ly,lz);var X=P[0],Y=P[1],Z=P[2],sc=P[3],al=1;
      var dly=q.d;if(c.release==='sequence')dly=q.second?q.d*.4:.48+q.d*.5;else if(c.release==='burst')dly=q.d<.3?q.d*.35:.22+q.d*.72;
      var lt=smooth(rel,dly,dly+.18);
      if(lt>0){var bu=c.release==='burst',tx=cx+q.rx*R*(bu?4.4:3.4)*(.35+.65*lt),ty=(c.release==='scent')?cy-R*(1.3+q.ry*1.6)*lt:skinTop+R*(bu?(.06+q.ry*.55):(.12+q.ry*.95))*lt;
        X=lerp(X,tx,lt);Y=lerp(Y,ty,lt);Z=lerp(Z,-1,lt);al=1-lt*.5;sc*=1-.45*lt;}
      items.push({z:Z,x:X,y:Y,r:R*lerp(.06,.045,scq)*sc*q.sz2,img:q.second?this.spr.act2:this.spr.act,a:al*(1-zoom*(lt>0?1:.6))});}
    /* shell points */
    var reform=1-smooth(zoom,0,.7),sR=lerp(1.75,1,shellK),open=c.release==='burst'?rel*reform:c.release==='sequence'?smooth(rel,.45,1)*reform:rel,crk=smooth(rel,0,.45)*reform;
    if(shellK>.01){for(i=0;i<this.S.length;i++){q=this.S[i];var sa2=smooth(shellK,q.d*.6,q.d*.6+.4),e=1;
        if(open>0&&c.release==='burst'){var bo=smooth(open,0,.55);e=1+bo*(.9+q.d*1.4);sa2*=1-smooth(open,.08,.6);}
        else if(open>0&&q.y>.45){e=1+open*.35*(q.y-.45);sa2*=1-open*.7*(q.y-.3);}
        P=proj(q.x*sR*e,q.y*sR*e,q.z*sR*e);
        items.push({z:P[2],x:P[0],y:P[1],r:R*(c.shell==='polymer'?.034:.03)*P[3],img:this.spr.shell,a:sa2*(c.shell==='polymer'?.5:.9)});}}
    /* second shell (MultiSal) */
    if(shell2>.01){for(i=0;i<this.S.length;i+=2){q=this.S[i];var e2=1.28*lerp(1.5,1,shell2)*(1+crk*(.5+q.d*.9));P=proj(q.x*e2,q.y*e2,q.z*e2);
        items.push({z:P[2],x:P[0],y:P[1],r:R*.032*P[3],img:this.spr.shell2,a:smooth(shell2,q.d*.5,q.d*.5+.5)*.75*(1-smooth(crk,.05,.7))});}}

    items.sort(function(a,b){return b.z-a.z;});
    var glassDone=false,self=this;
    function glass(){
      var gk=shellK*(c.release==='burst'?1-smooth(open,.02,.35):1);
      if(gk<.02)return;var gp=proj(0,0,0),GR=R*sR*gp[3]*1.04;g.save();var shellK_=shellK;shellK=gk;
      var gg=g.createRadialGradient(gp[0]-GR*.35,gp[1]-GR*.4,GR*.05,gp[0],gp[1],GR);
      gg.addColorStop(0,'rgba(255,255,255,'+(.42*shellK)+')');gg.addColorStop(.55,'rgba(255,255,255,'+(.06*shellK)+')');gg.addColorStop(1,'rgba(255,255,255,'+(.18*shellK)+')');
      g.fillStyle=gg;g.beginPath();g.arc(gp[0],gp[1],GR,0,6.283);g.fill();
      var a=hexRgb(c.c1);g.strokeStyle='rgba('+a+','+(.45*shellK*(1-rel*.4))+')';g.lineWidth=2;g.stroke();
      g.globalAlpha=.55*shellK;g.fillStyle='#fff';g.beginPath();g.ellipse(gp[0]-GR*.42,gp[1]-GR*.5,GR*.22,GR*.1,-.6,0,6.283);g.fill();
      if(c.shell==='polymer'){g.globalAlpha=1;g.strokeStyle='rgba('+a+','+(.26*shellK)+')';g.lineWidth=Math.max(5,GR*.1);g.beginPath();g.arc(gp[0],gp[1],GR*.97,0,6.283);g.stroke();}
      shellK=shellK_;g.restore();glassDone=true;
    }
    for(i=0;i<items.length;i++){var it=items[i];
      if(!glassDone&&it.z<0)glass();
      if(it.a<=.01||it.r<=.3)continue;g.globalAlpha=it.a;g.drawImage(it.img,it.x-it.r,it.y-it.r,it.r*2,it.r*2);}
    if(!glassDone)glass();
    g.globalAlpha=1;

    /* surface charges */
    if(charge>.02&&c.charge==='plus'){g.save();g.font='700 '+Math.max(10,R*.11)+'px ui-sans-serif,system-ui';g.textAlign='center';g.textBaseline='middle';
      for(i=0;i<this.Q.length;i++){q=this.Q[i];P=proj(q.x,q.y,q.z);var fr=P[2]<0?1:.45,qr=R*.058*P[3];
        g.globalAlpha=charge*fr;g.fillStyle=c.c1;g.beginPath();g.arc(P[0],P[1],qr,0,6.283);g.fill();g.fillStyle='#fff';g.fillText('+',P[0],P[1]+.5);}
      g.restore();}

    /* HydroSal: moisture drops onto the capsule, then a burst ring on application */
    if(c.release==='burst'||c.release==='sequence'){
      var drip=smooth(s,2.25,2.85)*(1-smooth(s,3.45,3.9))*(1-zoom);
      if(drip>.02){g.save();var a3=hexRgb(c.c1);
        var hg=R*2.3;g.globalAlpha=drip*.55;g.drawImage(this.glowC1,cx-hg,cy-hg,hg*2,hg*2);
        for(i=0;i<7;i++){var dp=((t*.55+i*.143)%1),dx=cx+(i-3)*R*(c.shell==='double'?.36:.29)+Math.sin(i*2.1)*R*.06,hr=c.shell==='double'?1.34:1.05,top=cy-R*1.8,hit=cy-R*Math.sqrt(Math.max(0,1-Math.pow((dx-cx)/(R*hr*1.05),2)))*hr,dy=lerp(top,hit,Math.min(1,dp*1.25)),dr=Math.max(4,R*.075);
          if(dp*1.25<1){g.globalAlpha=drip*.9*Math.min(1,dp*6);g.fillStyle='rgba('+a3+',.85)';g.beginPath();g.moveTo(dx,dy-dr*2.2);g.quadraticCurveTo(dx+dr,dy-dr*.4,dx+dr,dy+dr*.2);g.arc(dx,dy+dr*.2,dr,0,Math.PI);g.quadraticCurveTo(dx-dr,dy-dr*.4,dx,dy-dr*2.2);g.fill();
            g.globalAlpha=drip*.8;g.fillStyle='#fff';g.beginPath();g.arc(dx-dr*.35,dy,dr*.28,0,6.283);g.fill();}
          else{var sp2=(dp*1.25-1)/.25;g.globalAlpha=drip*(1-sp2)*.7;g.strokeStyle='rgba('+a3+',.9)';g.lineWidth=1.5;g.beginPath();g.ellipse(dx,hit,dr*(1+sp2*3),dr*(.4+sp2*1.1),0,0,6.283);g.stroke();}}
        g.restore();}
      if(rel>.01&&rel<.75){g.save();var a4=hexRgb(c.c1);for(i=0;i<2;i++){var bp=smooth(rel,.02+i*.08,.55+i*.08);if(bp<=0||bp>=1)continue;
          g.globalAlpha=(1-bp)*.75;g.strokeStyle='rgba('+a4+',1)';g.lineWidth=3*(1-bp)+1;g.beginPath();g.arc(cx,cy,R*(1+bp*2.4),0,6.283);g.stroke();}
        g.restore();}
    }
    /* scent waves (SalScent) during release */
    if(rel>.02&&c.release==='scent'){g.save();g.strokeStyle=c.act;g.lineWidth=2;
      for(i=0;i<3;i++){var ph2=((t*.5+i/3)%1),wr=R*(1+ph2*1.8);g.globalAlpha=rel*(1-ph2)*.6;g.beginPath();g.arc(cx,cy,wr,Math.PI*1.1,Math.PI*1.9);g.stroke();}g.restore();}
    g.globalAlpha=1;
  };

  function boot(){document.querySelectorAll('[data-svb]').forEach(function(el){if(!el._svb)el._svb=new Build(el);});}
  if(document.readyState!=='loading')boot();else document.addEventListener('DOMContentLoaded',boot);
  document.addEventListener('shopify:section:load',boot);
})();
